import React from 'react'
import { Col, Row } from 'antd'
import { FormikProps } from 'formik'
import { useTranslation } from 'react-i18next'

import { DatePicker, Input } from 'src/components/Formik'
import { Title } from 'src/components/Ant'

import { InitialValues } from '../initial-values'

interface Props {
  formikProps: FormikProps<InitialValues>
}
export default function UserAirInfo({ formikProps }: Props) {
  const { t } = useTranslation()
  return (
    <>
      <Title level={4}>
        {t('web.user.common.mandatory_for_international_air')}
      </Title>
      <Row gutter={24}>
        <Col span={8}>
          <Input
            formikProps={formikProps}
            label="web.user.common.passport_number.title"
            name="passport_number"
            required={false}
          />
        </Col>
        <Col span={8}>
          <DatePicker
            formikProps={formikProps}
            label="web.user.common.expiration.title"
            name="passport_expires_on"
            required={false}
          />
        </Col>
      </Row>
    </>
  )
}
